import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useLocation, useNavigate} from 'react-router-dom';

const Failed = () => {
  const navigate = useNavigate();
  const {state}: IuseLocationState = useLocation();
  return (
    <div className="w-full h-dvh flex items-center justify-center">
      <div className="text-center w-4/5">
        <SpanIcon className="icon-size24171 bg-red-600 rounded-full text-white text-4xl p-3 font-black" />
        <h2 className="text-red-600 text-lg mt-5 mb-12">عملیات ناموفق</h2>

        <p className="text-sm text-gray-900 font-medium mb-7 text-justify">
          پرداخت شما{' '}
          {state?.data?.RRN ? ` با شماره پیگیری ${state.data.RRN}` : null}{' '}
          ناموفق بود. برای فعالسازی حساب مورد نظرتان دوباره تلاش کنید. چنانچه طی
          این فرآیند مبلغی از حسابتان کم شده است طی 72 ساعت آینده به حسابتان
          برمی‌گردد.
        </p>
        <button
          onClick={() => navigate('/sponsor/new-plan')}
          className="bg-green-500 text-white rounded-md px-8 py-2 text-md w-full border-none"
        >
          بازگشت به مزرعه
        </button>
      </div>
    </div>
  );
};

export default Failed;
